import { render, staticRenderFns } from "./OrderGalleryDialog.vue?vue&type=template&id=4cca4a90&scoped=true"
import script from "./OrderGalleryDialog.vue?vue&type=script&lang=js"
export * from "./OrderGalleryDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderGalleryDialog.vue?vue&type=style&index=0&id=4cca4a90&prod&lang=scss"
import style1 from "./OrderGalleryDialog.vue?vue&type=style&index=1&id=4cca4a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cca4a90",
  null
  
)

export default component.exports